<script setup>
// import i18n from "@/i18n"
import { ref, onMounted,provide } from "vue"
import { showMessage } from "@/utils/hooks/message"
import { getBusinessInfoDetail } from "@/service/index"
import accountInfoCom from "./components/accountInfo1.vue"
import { useRouter } from "vue-router"
import { getLangValue} from "@/utils/common"; //获取后端语言
const PageHeaderT =getLangValue("my.account", "title1")
const PageHeaderItems = [
    // {
    //     text: getLangValue("menu", "my"),
    //     active: false,
    // },
    {
        text: getLangValue("my.account","title"),
        active: true,
        href: '/account',
    },
    {
        text: getLangValue("my.account", "title1"),
        active: true,
    },
]
const detailInfo = ref({})
const router = useRouter()
provide('detailInfo', detailInfo)
const getStatusFun = async () => {
    // 是否有数据在审核  有的话就在第三步   没有的话就在默认的第一步  失败的话在第4步  第4步可以重新提交信息
    // let status = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).status : ''
    // 0-未审核-待完善资料  1-审核通过  2待审核-已完善资料  3待审核-更新除联系人/手机号码/公司邮箱/联系人邮箱/座机号码 4审核完善资料-未通过  5 审核更新资料-未通过
    // console.log(status);
    let user_id = sessionStorage.getItem('set_menu_list') ? JSON.parse(sessionStorage.getItem('set_menu_list')).user_id : ''
    if (user_id === '' || typeof user_id == 'undefined') {
        showMessage('danger', getLangValue("base", "request403"))
        router.push({ path: '/login' })
    } else {
        const resp = await getBusinessInfoDetail(user_id);
        detailInfo.value = resp.payload  
    }
}


onMounted(() => {
    // 初始状态
    getStatusFun();
    // detailInfo.value =
    // {
    //     "company_name": "金科组数",
    //     "company_type": "生产商",
    //     "contact_first_name": "feng",
    //     "contact_last_name": "tao",
    //     "contact_email": "11107949255@qq.com",
    //     "landline_number": "2659866",
    //     "mobile_phone_number": "15108343658",
    //     "certification_company": true,
    //     "business_scope": "服装数据库,纱线数据库",
    //     "place_of_incorporation": "dwq ",
    //     "certificate_number": "dwq131",
    //     "company_qualification": [
    //         "66988197b9fc9a463208f059"
    //     ],
    //     "logo": [
    //         "66988197b9fc9a463208f059"
    //     ],
    //     "Enterprise_registered_country": "阿富汗",
    //     "phoneCountry": "阿富汗",
    //     "phone_numberCountry": "安哥拉",
    //     "company_address": [
    //         {
    //             "name": "AF",
    //             "country": "阿富汗",
    //             "province": "11",
    //             "city": "11",
    //             "address1": "1",
    //             "address2": "",
    //             "address3": "",
    //             "postcode": "1"
    //         },
    //         {
    //             "name": "AF",
    //             "country": "阿富汗",
    //             "province": "1",
    //             "city": "11",
    //             "address1": "1",
    //             "address2": "",
    //             "address3": "",
    //             "postcode": "1"
    //         }
    //     ]
    // }
})
</script>
<template>
    <Layout>
        <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
        <div style="overflow-x: auto; overflow-y: hidden; height: calc(100vh - 140px);">
            <!-- 展示信息 -->
            <div class="w-100 h-100  py-8 my-scroll-bar">
               <accountInfoCom />
            </div>
        </div>
    </Layout>
</template>
<style scoped>
.active {
    background-color: #0AB39C !important;
}

.form-control {
    color: #888a97;
}
</style>